import React from 'react';
import Typical from 'react-typical';
import headlines from './headlines';

const calculateYearsOfExperience = () => {
  const startDate = new Date("2017-02-01");
  const now = new Date();
  const diffInMs = now.getTime() - startDate.getTime();
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 365.25));
};

const Home = () => {
  const yearsOfExperience = calculateYearsOfExperience();
  return (
    <div className="section" id="home">
      <div className="container">
        <div className="disply-table">
          <div className="table-cell">
            <h4 id="name" style={{ color: '#009DFE' }}>
              Shaeen Singh
            </h4>
            <h1 style={{ color: '#FFF' }}>
              <Typical
                steps={headlines}
                loop={Infinity}
                wrapper="span"
              />
            </h1>
            <p style={{ color: '#CCC', maxWidth: 500 }}>
              Fullstack Engineer with {yearsOfExperience}+ years' experience building scalable systems and leading high-performing teams.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
